/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query IpDirectoryReadQuery($take: PositiveInt!, $skip: Int!) {
    IpDirectoryRead(take: $take, skip: $skip) {
      message,
      status,
      id,
      displayName
    }
  }
`
